export const SET_SNAPSHOTS = 'SET_SNAPSHOTS';
export const SET_CURRENT_SNAPSHOT = 'SET_CURRENT_SNAPSHOT';
export const SET_PLACES = 'SET_PLACES';
export const UPDATE_PLACES = 'UPDATE_PLACES';
export const SET_SERVICE_GROUPS = 'SET_SERVICE_GROUPS';
export const SET_SERVICES = 'SET_SERVICES';
export const UPDATE_SERVICES = 'UPDATE_SERVICES';
export const SET_ACTORS = 'SET_ACTORS';
export const SET_VARS = 'SET_VARS';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_SCENES = 'SET_SCENES';
export const SET_SCENES_VARS = 'SET_SCENES_VARS';
export const ADD_VARS_INTO_SCENE = 'ADD_VARS_INTO_SCENE';
export const ADD_SCENE = 'ADD_SCENE';
export const UPDATE_SCENE = 'UPDATE_SCENE';
export const REMOVE_SCENE = 'REMOVE_SCENE';
export const REMOVE_SCENE_VARS = 'REMOVE_SCENE_VARS';
export const UPDATE_SCENE_VAR_VALUE = 'UPDATE_SCENE_VAR_VALUE';
export const MARK_VAR_AS_WAITING = 'MARK_VAR_AS_WAITING';
export const MARK_VAR_AS_UPTODATE = 'MARK_VAR_AS_UPTODATE';
export const SET_VARS_VALUE = 'SET_VARS_VALUE';
export const SET_RAW_VARS_VALUES = 'SET_RAW_VARS_VALUES';
export const ADD_SERVICE_INTO_SCENE = 'ADD_SERVICE_INTO_SCENE';
export const REMOVE_SERVICE_FROM_SCENE = 'REMOVE_SERVICE_FROM_SCENE';
export const REMOVE_VARS_FROM_SCENE = 'REMOVE_VARS_FROM_SCENE';
export const SET_SPACEPLANS = 'SET_SPACEPLANS';
export const ADD_SPACEPLAN = 'ADD_SPACEPLAN';
export const UPDATE_SPACEPLAN = 'UPDATE_SPACEPLAN';
export const REMOVE_SPACEPLAN = 'REMOVE_SPACEPLAN';
export const SET_SPACEPLAN_ITEMS = 'SET_SPACEPLAN_ITEMS';
export const ADD_SPACEPLAN_ITEM = 'ADD_SPACEPLAN_ITEM';
export const REMOVE_SPACEPLAN_ITEM = 'REMOVE_SPACEPLAN_ITEM';
export const UPDATE_SPACEPLAN_ITEM = 'UPDATE_SPACEPLAN_ITEM';
export const SET_VARS_LOGGING_ENABLED = 'SET_VARS_LOGGING_ENABLED';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
export const SET_NOTIFICATION_ENABLED = 'SET_NOTIFICATION_ENABLED';
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';

export const ADD_EXPANDED_ITEM_INTO_MENU = 'ADD_EXPANDED_ITEM_INTO_MENU';
export const REMOVE_EXPANDED_ITEM_FROM_MENU = 'REMOVE_EXPANDED_ITEM_INTO_MENU';

export const SET_APPLICATION_STATE = 'SET_APPLICATION_STATE';
export const SELECT_SERVICE = 'SELECT_SERVICE';
export const DESELECT_SERVICE = 'DESELECT_SERVICE';
export const CLEAR_SERVICE_SELECTION = 'CLEAR_SERVICE_SELECTION';

export const SET_PERMISSIONS = 'SET_PERMISSIONS';

export const DISABLE_SERVICES_SELECTION = 'DISABLE_SERVICES_SELECTION';
export const TOGGLE_SERVICES_SELECTION = 'TOGGLE_SERVICES_SELECTION';
export const TOGGLE_SERVICE_SELECTED = 'TOGGLE_SERVICE_SELECTED';
export const SET_FAVORITE_SERVICE = 'SET_FAVORITE_SERVICE';
export const SET_FAVORITE_SCENE = 'SET_FAVORITE_SCENE';
export const SET_CLOUD_STATUS = 'SET_CLOUD_STATUS';
export const SET_ONLINE_STATUS = 'SET_ONLINE_STATUS';
export const UPDATE_NAVIGATION_SETTINGS = 'UPDATE_NAVIGATION_SETTINGS';

export const SET_PAID_SUBSCRIPTION = 'SET_PAID_SUBSCRIPTION';
